import React from "react";
import "./button.css";

interface SimpleOutlineButtonProps {
  label: string;
  onClick?: () => void;
  type?: "button" | "submit" | "reset";
  form?: string;
  background?: string;
  className?: string;
  padding?: string;
  style?: React.CSSProperties;
  isDisabled?: boolean;
  isLoading?: boolean;
}

const SimpleOutlineButton: React.FC<SimpleOutlineButtonProps> = ({
  label,
  onClick,
  type = "button",
  form,
  background,
  padding,
  className = "",
  style = {},
  isDisabled = false,
  isLoading = false,
}) => {
  return (
    <button
      type={type}
      onClick={onClick}
      form={form}
      className={`btn-simple-outline-primary ${className}`}
      style={{
        background,
        padding,
        ...style,
      }}
      disabled={isDisabled || isLoading}
    >
      {isLoading ? (
        <>
          <span
            className="btn-spinner"
            style={{
              borderColor: "var(--Grey-Subtext2)",
              borderTopColor: "var(--Primary-Regular)",
            }}
            aria-hidden="true"
          />
          {label}
        </>
      ) : (
        label
      )}
    </button>
  );
};

export default SimpleOutlineButton;
